<div class="card data-card h-100" [class.border-request]="item['requestDate'] && !item['fileExtension']">
  <div class="card-body">
    <div class="card-left pe-2">
      <div>
        <i class="icon icon-file-{{item['fileExtension']}}"></i>
      </div>
    </div>
    <div class="card-content">
      @if (item['name']) {
        <h5 class="card-title">{{ item["name"] }}</h5>
      }
      @if (item['creationDate']) {
        <span class="card-subtitle text-muted mb-1">
          <i class="mdi mdi-calendar-plus me-1"></i>
          {{ item['creationDate'] | date : "dd/MM/yyyy HH:mm" }}
        </span>
      }
      @if (item['size']) {
        <span class="card-subtitle text-muted mb-1">
          <i class="mdi mdi-attachment me-1"></i>
          {{ item['size'] | fileSize }}
        </span>
      }
    </div>
  </div>
  @if (item['fileExtension']) {
    <div class="card-ur-corner-wrapper-bottom-right">
      <div class="dropdown card-menu">
        <button class="btn btn-outline-primary"
          [style.font-size]="'30px'"
          type="button"
          title="Télécharger"
          (click)="onClickDownload(item)"
          >
          @if (!downloadFinished) {
            <i class="mdi mdi-cloud-download"></i>
          }
          @if (downloadFinished) {
            <i class="mdi mdi-cloud-check"></i>
          }
        </button>
      </div>
    </div>
  }
</div>
